import React from 'react';
import { useParams } from 'react-router-dom';
import { CmsPage } from 'src/components';

var ColletionLanding = function ColletionLanding() {
  var _useParams = useParams(),
      collectionsSlug = _useParams.collectionsSlug;

  return React.createElement(CmsPage, {
    identifier: collectionsSlug
  });
};

export default ColletionLanding;